// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"createNewAdvertiserShort_buttonsWrapper__texv5","wrapper":"createNewAdvertiserShort_wrapper__6ZDdg"};